export default "__VITE_ASSET__Cw4z4F$$__"